import { render } from "./VF-radio.vue?vue&type=template&id=0d0d0717"
import script from "./VF-radio.vue?vue&type=script&lang=js"
export * from "./VF-radio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__